import { render, staticRenderFns } from "./DetailsLayout.vue?vue&type=template&id=44edd248&scoped=true&"
import script from "./DetailsLayout.vue?vue&type=script&lang=ts&"
export * from "./DetailsLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsLayout.vue?vue&type=style&index=0&id=44edd248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44edd248",
  null
  
)

export default component.exports